import LoadingCircle from "reports/components/simple/LoadingCircle";
import EOSReport from "../../../../components/Reports/EOSReport";
import { isEmpty } from "lodash";
import MetricAndPnLBreakdowns from "../../../../components/Reports/GenericCharts/MetricAndPnLBreakdowns/MetricAndPnLBreakdowns";
import {
  useIs24Hours,
  useIsWeekly,
  useProcessGroupNameAndMachemetryIds,
} from "../../../../components/Reports/reportUtils";
import PnLChart from "../../../../components/Reports/GenericCharts/PnLChart/PnLChart";
import useEosData from "reports/store/useEosData";
import { MetricEnum } from "reports/utils/metricTypes";
import MeritmedicaltijuanaSummaryMetrics from "./MeritmedicaltijuanaSummaryMetrics";
import { ShiftPnlBreakdowns } from "reports/components/Reports/GenericCharts/MetricAndPnLBreakdowns/ShiftPnlBreakdowns";
import { getPnlTimesWithProducingLosses } from "../../../../components/Reports/GenericCharts/PnLChart/pnlChartUtils";
import { ProducingLossesEnum } from "../../../../types";
import { black } from "reports/constants/colors";
import { useReportConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

export default function MeritmedicaltijuanaEOS() {
  const { processGroupName, machemetryIds } =
    useProcessGroupNameAndMachemetryIds({ defaultProcessGroupName: "All" });

  // EOS needs ge and lt url params, sample is Aug3, 2022, 6:30AM - 6:30PM
  const sampleLink = `/${processGroupName}?ge=1659522600000&lt=1659565800000`;

  const is24Hour = useIs24Hours();
  const isWeekly = useIsWeekly();
  const shouldShowShiftBreakdown = is24Hour || isWeekly;

  const LINE_TO_PROCESS_GROUP_MAPPING = {
    "meritmedical-tijuana_d_001": "Molding",
    "meritmedical-tijuana_d_002": "Molding",
    "meritmedical-tijuana_d_003": "VS2",
    "meritmedical-tijuana_d_004": "VS2",
    "meritmedical-tijuana_d_006": "VS3",
    "meritmedical-tijuana_d_013": "VS4",
    "meritmedical-tijuana_d_011": "VS4",
    "meritmedical-tijuana_d_012": "VS5",
  };

  const flightGroup =
    processGroupName == "All"
      ? "All"
      : LINE_TO_PROCESS_GROUP_MAPPING[machemetryIds[0]];

  return (
    <>
      {machemetryIds && machemetryIds.length > 0 ? (
        <EOSReport
          machemetryIds={machemetryIds}
          sampleLink={sampleLink}
          flightTimelineLinkGroup={
            !isWeekly && flightGroup ? flightGroup : undefined
          }
          shouldShowPrint={false}
          shouldSkipSkuData={false}
          shouldFetchDataByShift={shouldShowShiftBreakdown}
        >
          <MeritmedicaltijuanaEosComponents
            {...{
              processGroupName,
              machemetryIds,
              shouldShowShiftBreakdown,
              isWeekly,
            }}
          />
        </EOSReport>
      ) : (
        <LoadingCircle
          logAfterTimeout={{
            logData: { machemetryIds },
            delay: 5 * 1000,
          }}
        />
      )}
    </>
  );
}

function MeritmedicaltijuanaEosComponents({
  processGroupName,
  machemetryIds,
  shouldShowShiftBreakdown,
}) {
  const { data } = useEosData();
  const reportConfig = useReportConfig();

  const summaryMetricsInputList = reportConfig?.eosReportMetricsConfig
    ?.summaryMetricsInputList ?? [
    { name: MetricEnum.OEE, color: black },
    { name: MetricEnum.AVAIL, color: black },
    { name: MetricEnum.QUALITY, color: black },
    { name: MetricEnum.PERF, color: black },
    { name: MetricEnum.TAGGING, color: black },
    { name: MetricEnum.COUNT, title: "Accepted Parts" },
    { name: MetricEnum.REJECT_COUNT, title: "Rejected Parts" },
  ];

  return data && !isEmpty(data) && machemetryIds && machemetryIds.length > 0 ? (
    <>
      <MeritmedicaltijuanaSummaryMetrics {...{ data, processGroupName }} />
      <PnLChart
        pnlTimes={getPnlTimesWithProducingLosses({
          data,
          producingLossesToSkip: [
            ProducingLossesEnum.effectiveProducingTime,
            ProducingLossesEnum.qualityLoss,
            ProducingLossesEnum.slowdownLoss,
          ],
        })}
      />
      {shouldShowShiftBreakdown && (
        <ShiftPnlBreakdowns summaryMetricsInputList={summaryMetricsInputList} />
      )}
      <MetricAndPnLBreakdowns
        machemetryIds={machemetryIds}
        summaryMetricsInputList={summaryMetricsInputList}
        showReportLink
      />
    </>
  ) : (
    <LoadingCircle
      logAfterTimeout={{
        logData: { eosData: data, machemetryIds },
        delay: 5 * 1000,
      }}
    />
  );
}
